import api from '@/store/api/customer/product/number/revisions'
import * as mutationTypes from './mutation-types'

const initialState = () => ({
    revision: {
        next: {},
        revision: {},
        previous: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        next: state => state.revision?.next ?? {},
        revision: state => state.revision?.revision ?? {},
        previous: state => state.revision?.previous ?? {}
    },
    actions: {
        /**
         * @param {{customerId: number, number: string, revisionId: number}} data
         * @returns {Promise<*>}
         */
        showRevision: async ({commit, dispatch}, data) => {
            try {
                const response = await api.showRevision(data)
                commit(mutationTypes.SET_REVISION, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetRevision: async ({commit}) => commit(mutationTypes.RESET_REVISION)
    },
    mutations: {
        [mutationTypes.SET_REVISION]: (state, data) => state.revision = data,
        [mutationTypes.RESET_REVISION]: (state) => Object.assign(state, initialState())
    }
}
